import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '../store/Localize'
import Resx from './Resx'

class LanguageSwitch extends React.Component {
  render () {
    return (
      <a href='/' className='nav-link' onClick={this.onClick}><Resx name='Common.SwitchLanguage' /></a>
    )
  }

  onClick = e => {
    e.preventDefault()
    const { locale, loadResources } = this.props
    loadResources(locale !== 'en' ? 'en' : 'ar')

    for (let i = window.localStorage.length - 1; i >= 0; i--) {
      let itemName = window.localStorage.key(i)
      if (itemName.includes('grid-options')) {
        let item = JSON.parse(window.localStorage.getItem(window.localStorage.key(i)))
        item.filter = null
        window.localStorage.setItem(itemName, JSON.stringify(item))
      }
    }
  };
}

export default connect(mapStateToProps, {
  loadResources: actionCreators.loadResources
})(LanguageSwitch)

function mapStateToProps (state) {
  return {
    locale: state.localization.locale
  }
}



// WEBPACK FOOTER //
// ./src/components/LanguageSwitch.js